import { A } from '../components/Content';
import { CodeDemoPreview } from '@vz/ui/components/CodeDemo/CodeDemoPreview';
import { Code } from '@vz/ui/pkg/Code';
import { CodeDemo, EmbeddableCodeDemo } from '@vz/ui/components/CodeDemo';

export const mdxComponents = {
  a: A,
  // pre: CodeBlock
  code: Code,

  Code,
  CodeDemo,
  EmbeddableCodeDemo,
  CodeDemoPreview
};
